import React, { useState, useEffect } from 'react';
import PlanSearch from './plan-search';
import PuSearch from './pu-search';

import './style.scss';
import SuList from './su-list';

const EditFollowers = () => {

    const [planName, setPlanName] = useState('');
    const [errors, setErrors] = useState({});
    const [status, setStatus] = useState('expired');
    const [refetch, setRefetch] = useState(0);
    const [loading, setLoading] = useState(false);
    const [selectedSus, setSelectedSus] = useState([]);
    const [selectedPus, setSelectedPus] = useState([]);
    const [selectedPlan, setSelectedPlan] = useState([]);
    const [selectedFollower, setSelectedFollower] = useState([]);

    const handleLoad = () => {
        setRefetch(refetch => refetch += 1);
    };

    return <div className="edit-followers">
        <h3 className="mb-4">Edit New Followers To Creator</h3>

        <div className="mt-3">
            <div className="filters">
                <label className="filters__label">Search List Users</label>

                <div className="row">
                    <div className='col-md-3'>
                        <div className="form-group">
                            <PuSearch
                                selectedPus={selectedPus}
                                setSelectedPus={setSelectedPus}
                            />
                        </div>
                        <div className='form-group' style={{ flex: '100%' }}>
                            <PlanSearch
                                selectedPlan={selectedPlan}
                                setSelectedPlan={setSelectedPlan}
                                disable={!['1-month', 'recurring'].includes(status)}
                            />
                        </div>
                    </div>

                    <div className='col-sm-4 col-md-2'>
                        {/* <div className="form-check">
                            <input
                                type="radio"
                                name="status"
                                id="status"
                                value="expired"
                                className="form-check-input"
                                checked={status === 'expired'}
                                onChange={e => setStatus('expired')}
                            />
                            <label className="form-check-label" htmlFor="status">
                                Expired Status
                            </label>
                        </div> */}
                        <div className="form-check">
                            <input
                                type="radio"
                                name="status"
                                id="status"
                                value="free"
                                className="form-check-input"
                                checked={status === 'free'}
                                onChange={e => setStatus('free')}
                            />
                            <label className="form-check-label" htmlFor="status">
                                Free Follow
                            </label>
                        </div>
                        {/* <div className="form-check">
                            <input
                                type="radio"
                                name="status"
                                id="status"
                                value="1-month"
                                className="form-check-input"
                                checked={status === '1-month'}
                                onChange={e => setStatus('1-month')}
                            />
                            <label className="form-check-label" htmlFor="status">
                                1 Month Subscription
                            </label>
                        </div>
                        <div className="form-check">
                            <input
                                type="radio"
                                name="status"
                                id="status"
                                value="recurring"
                                className="form-check-input"
                                checked={status === 'recurring'}
                                onChange={e => setStatus('recurring')}
                            />
                            <label className="form-check-label" htmlFor="status">
                                Recurring Subscription
                            </label>
                        </div> */}
                    </div>

                    <div className='col-md-3'>
                        <button
                            className='btn btn-primary btn-rounded'
                            onClick={handleLoad}
                            disabled={loading}
                            style={{ minWidth: 150 }}
                        >
                            {loading ? 'Loading...' : 'Load Follower List'}
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div className="mt-3">
            <SuList
                status={status}
                planName={planName}
                refetch={refetch}
                selectedSus={selectedSus}
                selectedPus={selectedPus}
                setSelectedSus={setSelectedSus}
                setLoading={setLoading}
                selectedPlan={selectedPlan}
                setSelectedFollower={setSelectedFollower}
                selectedFollower={selectedFollower}
            />
        </div>

    </div>;
};

export default React.memo(EditFollowers);;